// extracted by mini-css-extract-plugin
export default {"dialog-content":"h9Px17mYfNMTLxn_2VwE"};